<template>
  <div class="w-10/12">
    <div style="height:100%" v-if="loading">
      <loader size="xxs" :loader-image="false" />
    </div>
    <div v-else class=" mt-6">
      <div class=" w-full">
        <p class=" font-semibold mb-7 inline-block">
          Employment Details
        </p>
      </div>
      <div
        class="grid grid-cols-12 gap-6 text-darkPurple"
        style="margin-top:1.125rem"
      >
        <div class="col-span-3">
          <div class="text-sm mb-1 text-jet">
            Employee ID
          </div>
          <div class="disabled">
            {{ employment.employeeId }}
          </div>
        </div>
        <div class="col-span-3">
          <div class="text-sm mb-1 text-jet">
            Employment Type
          </div>
          <div class="disabled">
            {{ employment.employmentType }}
          </div>
        </div>
        <div class="col-span-3">
          <div class="text-sm mb-1 text-jet">
            Engagement Date
          </div>
          <div class="disabled">
            {{  employment.resumptionDate }}
          </div>
        </div>
        <div class="col-span-3">
          <div class="text-sm mb-1 text-jet">
            Office Location
          </div>
          <div class="disabled">
            {{
              employment.employeeOffice ? employment.employeeOffice.name : "N/A"
            }}
          </div>
        </div>
        <div class="col-span-3">
          <div class="text-sm mb-1 text-jet">
            Effective Payroll Date
          </div>
          <div class="disabled">
            {{ employmentDate }}
          </div>
        </div>
        <div class="col-span-3">
          <div class="text-sm mb-1 text-jet">
            Organisational Unit
          </div>
          <div class="disabled">
            {{ employment.orgFunction ? employment.orgFunction.name : "N/A" }}
          </div>
        </div>
        <div class="col-span-3">
          <div class="text-sm mb-1 text-jet">
            Position
          </div>
          <div class="disabled">
            {{
              employment.userDesignation
                ? employment.userDesignation.name
                : "N/A"
            }}
          </div>
        </div>
        <div class="col-span-3" v-if="jobClassification === 'jobCadre'">
          <div class="text-sm mb-1 text-jet">
            Administrative Position
          </div>
          <div class="disabled">
            {{
              administrative === 'yes' ? 'Yes' : 'No'
            }}
          </div>
        </div>
        <div class="col-span-3" v-if="jobClassification === 'jobCadre' && administrative === 'yes'">
          <div class="text-sm mb-1 text-jet">
            Organizational Unit
          </div>
          <div class="disabled">
            {{
              employment.administrativeFunction
                ? employment.administrativeFunction.name
                : "N/A"
            }}
          </div>
        </div>
        <div class="col-span-3" v-if="jobClassification === 'jobCadre' && administrative === 'yes'">
          <div class="text-sm mb-1 text-jet">
            Position
          </div>
          <div class="disabled">
            {{
              employment.administrativeDesignation
                ? employment.administrativeDesignation.name
                : "N/A"
            }}
          </div>
        </div>
        <div class="col-span-3" v-if="jobClassification === 'jobCadre' && administrative === 'yes'">
          <div class="text-sm mb-1 text-jet">
            Date of Appointment
          </div>
          <div class="disabled">
            {{
              employment.appointmentDate
                ? employment.appointmentDate
                : "N/A"
            }}
          </div>
        </div>
        <div class="col-span-3">
          <div class="text-sm mb-1 text-jet">
            {{ isJobLevel ? 'Job Level' : 'Grade Level' }}
          </div>
          <div class="disabled">
            {{ employment.userLevel ? employment.userLevel.name : "N/A" }}
          </div>
        </div>
        <div class="col-span-3">
          <div class="text-sm mb-1 text-jet">
            {{ isJobLevel ? 'Job Grade' : 'Step' }}
          </div>
          <div class="disabled">
            {{  employment.jobGrade ? employment.jobGrade : "N/A" }}
          </div>
        </div>
        <div class="col-span-3">
          <div class="text-sm mb-1 text-jet">
            Employee Status
          </div>
          <div class="disabled">
            {{ employment.isActive ? "Active" : "In Active" }}
          </div>
        </div>
        <div class="col-span-3">
          <div class="text-sm mb-1 text-jet">
            confirmation Status
          </div>
          <div class="disabled">
            {{ employment.employmentStatus }}
          </div>
        </div>
        <div class="col-span-3">
          <div class="text-sm mb-1 text-jet">
            Reporting To
          </div>
          <div class="disabled">
            {{
              employment.userReportingTo
                ? `${employment.userReportingTo.fname} ${employment.userReportingTo.lname}`
                : "Nil"
            }}
          </div>
        </div>
        <div class="col-span-3">
          <div class="text-sm mb-1 text-jet">
            Dotted Reporting
          </div>
          <div class="disabled">
            {{
              employment.dottedReportingTo
                ? `${employment.dottedReportingTo.fname} ${employment.dottedReportingTo.lname}`
                : "Nil"
            }}
          </div>
        </div>
      </div>
      <divider class="my-4" v-if="!isBasic && employment.employmentType === 'Independent Contractor'"/>
      <EmpIndContractor
        v-if="!isBasic && employment.employmentType === 'Independent Contractor'"
        :employment="employment"
      />
    </div>
  </div>
</template>

<script>
import Divider from "@/components/divider";
import organisationMixin from "@/utilities/organisationMixin";
import EmpIndContractor from "./empIndContractor";

export default {
  name: "EmploymentDelails",
  components: {
    Divider,
    organisationMixin,
    EmpIndContractor
  },

  data() {
    return {
      administrative: '',
      jobClassification: "",
      isJobLevel: true,
      employmentDate: "",
      allOrgUsers: [],
      reportingTo: "",
      loading: true,
      employment: {
        employeeId: "",
        employmentStatus: "",
        employmentType: "",
        isActive: null,
        orgFunction: {
          name: ""
        },
        userLevel: { name: "" },
        userDesignation: { name: "" },
        reportingTo: "",
        dottedReportingTo: "",
        resumptionDate: "",
        employeeOffice: { name: "" },

        businessAddress: null,
        businessCity: null,
        businessCountry: null,
        businessName: null,
        businessPostalCode: null,
        businessProofOfAddress: null,
        businessProofOfAddressFileSize: null,
        businessProofOfAddressFileType: null,
        businessProofOfAddressFileName: null,
        businessRegNumber: null,
        businessState: null,
        cacFileUrl: null,
        cacFileSize: null,
        cacFileType: null,
        cacFileName: null,
        contractorType: null,
        residencyStatus: null,
        taxCertificateFileUrl: null,
        taxCertificateFileSize: null,
        taxCertificateFileType: null,
        taxCertificateFileName: null,
        taxIdentificationNumber: null,
      }
    };
  },
  computed: {
    isBasic() {
      return (
        this.$store.state.subscription &&
        this.$store.state.subscription.plan === "basic"
      );
    },
    setFunctions() {
      return this.$store.state.org.getAllFunctions;
    },
    setDesignation() {
      return this.$store.state.org.getAllFunctions.find(
        item => item.id === this.employment.functionId
      );
    },
    setLevel() {
      let result;
      if (this.setDesignation) {
        result = this.setDesignation.designations.find(
          item => item.id === this.employment.designation
        );
      }

      return result ? result.level : "";
    }
  },
  methods: {
    async setAllOrgUsers(reportTo) {
      try {
        const { data } = await this.$_getAllOrgUsers("");
        const findDataIndex = data.findIndex(item => item.id === reportTo);
        this.reportingTo =
          findDataIndex >= 0 ? data[findDataIndex].name : "Nil";
      } catch (err) {
        throw new Error(err);
      }
    },
    getEmploymentInfo() {
      this.$_getOneEmployeeAll({
        id: this.$AuthUser.id
      })
        .then(({ data }) => {
          this.employment = data;
          this.setAllOrgUsers(data.reportingTo);
          this.employmentDate = this.employment.employmentDate;
          this.administrative = this.employment.administrativeDesignationId  ? 'yes' : 'no'
          this.loading = false;
        })
        .catch(err => {
          throw new Error(err);
        });
    }
  },
  async mounted() {
    const { data } = await this.$_getOrgProfile();
    this.isJobLevel = data.org.jobLevelProgression[0] === 'jobLevel' ? true : false;
    this.jobClassification = data.org.jobClassification;
    this.$_getHumanarLocations().then(result => {
      this.getEmploymentInfo();
      this.locationData = result.data.outlets;
    });
  }
};
</script>

<style></style>